import {
  Box,
  Button,
  Modal,
  TextField,
  ThemeProvider,
  Typography,
  createTheme,
} from "@mui/material";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import { useRecoilState } from "recoil";
import { myWalletBillModalState, selectedRefundItemState } from "../../../atoms/myWallet";
import { useCallback, useState } from "react";
import GetToday from "../../../utils/GetToday";
import { useDropzone } from "react-dropzone";
import axios from "../../../api/axios";
import { toast } from "react-toastify";
import uploadIcon from "../../../img/icons/upload_icon.svg";
import DowloadPdfView from "../../dowloadPdfView/DowloadPdfView";
import Errors from "../../../utils/Errors";

const theme = createTheme({
  components: {
    MuiModal: {
      styleOverrides: {
        root: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
        },
      },
    },
  },
});

const MyWalletRefundCompanyBillModal = () => {
  const [myWalletBillModal, setMyWalletBillModal] = useRecoilState(myWalletBillModalState);
  const [selectedRefundItem, setSelectedRefundItem] = useRecoilState(selectedRefundItemState);

  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [billDate, setBillDate] = useState(GetToday());
  const [billNo, setBillNo] = useState("");
  const [billAmount, setBillAmount] = useState("");
  const [sendFiles, setSendFiles] = useState([]);

  const handleBillDateChange = (e) => {
    setBillDate(e.target.value);
  };

  const handleBillNoChange = (e) => {
    setBillNo(e.target.value.toUpperCase());
  };

  const billAmountChange = (e) => {
    // Eğer değer nokta içeriyorsa, virgüle çevir
    const value = e.target.value.replace(",", ".");

    // Değer boşsa veya sadece rakamlar ve virgül içeriyorsa durumu güncelle
    if (value === "" || /^\d*([.,]\d{0,2})?$/.test(value)) {
      setBillAmount(value);
    }
  };

  const handleClose = useCallback(() => {
    setMyWalletBillModal(false);
    setSelectedRefundItem({});
    setSelectedDocuments([]);
    //iptal edildiginde inputlar temizlenir
    setBillDate(GetToday());
    setBillNo("");
    setBillAmount("");
    setSendFiles([]);
  }, [setMyWalletBillModal, setSelectedRefundItem, setSelectedDocuments]);

  const handleDrop = (acceptedFiles) => {
    const newFiles = acceptedFiles.map((file) => ({
      file,
      id: Math.random().toString(),
      type: file.type.split("/")[1].toLowerCase(),
    }));
    setSendFiles((prevFiles) => [...prevFiles, ...newFiles]);
    setSelectedDocuments((prevFiles) => [...prevFiles, ...newFiles]);
  };
  const handleSetState = (id) => {
    setSendFiles((prevFiles) => prevFiles.filter((file) => file.id !== id));
    setSelectedDocuments((prevFiles) => prevFiles.filter((file) => file.id !== id));
  };
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: handleDrop,
    multiple: true,
  });

  const uploadSelected = useCallback(() => {
    let formData = new FormData();
    Array.from(selectedDocuments).forEach((file, index) => {
      formData.append(`invoice_files[${index}]`, file.file);
    });
    formData.append("refund_from", "Kurumsal");
    formData.append("invoice_no", billNo);
    formData.append("invoice_date", billDate);
    formData.append("invoice_amount", Number(billAmount));

    axios
      .post(`refund/update/${selectedRefundItem.id}`, formData)
      .then(() => {
        toast.success("Dosyalar Başarıyla Yüklendi", { autoClose: 500 });
        setTimeout(() => {
          window.location.reload(true);
        }, 1000);
      })
      .catch((error) => Errors(error));
  }, [selectedRefundItem, selectedDocuments, billNo, billDate, billAmount]);

  return (
    <ThemeProvider theme={theme}>
      <Modal open={myWalletBillModal} onClose={handleClose}>
        <Box
          className="my-wallet-arrangement-bill-modal"
          style={{
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <Typography className="my-wallet-arrangement-bill-modal-headline" variant="h6">
            Kurumsal Üyelik
          </Typography>
          <Box className="my-wallet-arrangement-bill-modal-info">
            <CheckCircleOutlinedIcon />
            <Typography>
              Kurumsal müşteri olduğunuzdan tazmin iade faturası düzenlenmeniz gerekmektedir.
              Aşağıda belirtilmiş tutar kadar iade faturasını keserek sisteme işlemenizi rica
              ederiz.
            </Typography>
          </Box>
          <Box className="my-wallet-arrangement-bill-modal-inputs">
            <TextField
              fullWidth
              value={billDate}
              onChange={handleBillDateChange}
              autoComplete="off"
              type="date"
              label="Fatura Tarihi"
              size="small"
            />
            <TextField
              fullWidth
              value={billNo}
              onChange={handleBillNoChange}
              autoComplete="off"
              placeholder="GIB202300000563"
              label="Fatura Numarası"
              size="small"
            />
            <TextField
              fullWidth
              value={billAmount}
              onChange={billAmountChange}
              autoComplete="off"
              inputProps={{
                inputMode: "numeric",
              }}
              label="Fatura Tutarı"
              size="small"
            />
          </Box>
          <Box className="dropzone-wrapper">
            <Box className="dropzone">
              <div className="dropzone-area" {...getRootProps()}>
                <input {...getInputProps()} />
                <div className="dropzone-area-text">
                  <img src={uploadIcon} alt="Upload Icon" />
                  <span className="dropzone-area-text-headline">
                    Dosyayı sürükleyip bırakın veya{" "}
                    <span style={{ color: "var(--info)" }}>Gözat</span>
                  </span>
                  <span className="dropzone-area-text-sub">
                    Desteklenen Formatlar: JPEG, PNG, PDF
                  </span>
                </div>
              </div>
            </Box>
            <DowloadPdfView sendFiles={sendFiles} handleSetState={handleSetState} />
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "var(--gap)",
                width: "100%",
              }}
            >
              <Button className="iyzi-button" onClick={handleClose}>
                İptal
              </Button>
              <Button className="iyzi-button" onClick={uploadSelected}>
                Kaydet
              </Button>
            </Box>
          </Box>
          <Box>
            {selectedDocuments?.length !== 0 && (
              <Box
                sx={{
                  color: "var(--priceText)",
                  fontWeight: 700,
                  fontSize: "14px",
                  marginBottom: "20px",
                  marginTop: "20px",
                  paddingLeft: "8px",
                }}
              >
                Yüklenecek Dosyalar - {selectedDocuments?.length}
              </Box>
            )}
            {selectedDocuments?.length !== 0 &&
              selectedDocuments?.map((document, key) => (
                <Box
                  sx={{
                    border: "1px solid var(--phoneDigitBg)",
                    marginBottom: "10px",
                    padding: "10px",
                    borderRadius: "var(--wrapperBorderRadius)",
                    fontSize: "13px",
                    cursor: "pointer",
                    color: "var(--priceText)",
                    transition: "all 150ms linear",
                    ":hover": {
                      backgroundColor: "var(--pastelBlue)",
                      transition: "all 150ms linear",
                    },
                  }}
                  key={key}
                >
                  <span
                    style={{
                      fontSize: "13px",
                      color: "var(--priceText)",
                      fontWeight: "700",
                    }}
                  >
                    {key + 1}
                  </span>{" "}
                  - {document.file.name} / {document.file.type}
                </Box>
              ))}
          </Box>
        </Box>
      </Modal>
    </ThemeProvider>
  );
};

export default MyWalletRefundCompanyBillModal;
